/**
 * @generated SignedSource<<4da8fe507ec558091b0f126a173e2959>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SMTPConfigInput = {
  host: string;
  password: string;
  port: number;
  recipientAddress: string;
  senderAddress: string;
  username: string;
};
export type SettingsAlertsPageUpdateSmtpMutation$variables = {
  input: SMTPConfigInput;
};
export type SettingsAlertsPageUpdateSmtpMutation$data = {
  readonly updateSmtpConfig: {
    readonly success: boolean;
  };
};
export type SettingsAlertsPageUpdateSmtpMutation = {
  response: SettingsAlertsPageUpdateSmtpMutation$data;
  variables: SettingsAlertsPageUpdateSmtpMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateSmtpConfigPayload",
    "kind": "LinkedField",
    "name": "updateSmtpConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsAlertsPageUpdateSmtpMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsAlertsPageUpdateSmtpMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "40f78483660208d3d1afb587c44fd6d8",
    "id": null,
    "metadata": {},
    "name": "SettingsAlertsPageUpdateSmtpMutation",
    "operationKind": "mutation",
    "text": "mutation SettingsAlertsPageUpdateSmtpMutation(\n  $input: SMTPConfigInput!\n) {\n  updateSmtpConfig(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "c69330e85a6846981d30052c7e812517";

export default node;
